import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";

import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import orders from "./slices/orderSlice";
import airport from "./slices/airportSlice";
import menu from "./slices/menuSlice";
import invoice from "./slices/invoiceSlice";
import user from "./slices/userSlice";
import history from "./slices/historySlice";
import customers from "./slices/customerSlice";
import roles from "./slices/rolesSlice";
import announcements from "./slices/announcementSlice";
import reporting from "./slices/reportingSlice";

const createRootReducer = (asyncReducers = {}) =>
  combineReducers({
    theme,
    auth,
    orders,
    invoice,
    airport,
    menu,
    user,
    history,
    customers,
    roles,
    announcements,
    reporting,
    ...asyncReducers,
  });

const rootReducer =
  (asyncReducers = {}) =>
  (state, action) => {
    const seenAnnouncementIds = state?.announcements?.seenAnnouncementIds;

    if (action?.type === "auth/resetApp") {
      storage.removeItem("persist:root");
      localStorage.removeItem("auth_token");
      state = undefined;
    }

    const combinedReducer = createRootReducer(asyncReducers);
    const nextState = combinedReducer(state, action);

    if (action?.type === "auth/resetApp" && seenAnnouncementIds) {
      return {
        ...nextState,
        announcements: {
          ...nextState.announcements,
          seenAnnouncementIds,
        },
      };
    }

    return nextState;
  };

export default rootReducer;
